import { PERMISSIONS } from "@/app/_utils/permissions";
import { Calendar as CalendarMonthIcon, Home as HomeIcon, Mail as MailIcon, FileText as FileTextIcon, Link as LinkIcon, Workflow as WorkflowIcon,Drama as TheaterComedyIcon, Receipt as ReceiptLongIcon, Users as PeopleIcon, Store as StorefrontIcon, Home as HomeOutlinedIcon, Calendar as CalendarMonthOutlinedIcon, Users as PeopleOutlinedIcon, Drama as TheaterComedyOutlinedIcon, Building2 as ApartmentIcon, Receipt as ReceiptLongOutlinedIcon, BarChart3 as AnalyticsOutlinedIcon, BarChart3 as AnalyticsIcon, Inbox as InboxIcon, Tag as LocalOfferIcon, Lock as LockIcon, PartyPopper as PartyPopperIcon, MessagesSquare as MessagesSquareIcon, ListChecks as ListChecksIcon } from "lucide-react";

// Section headers carry the permission of their first child, so a section disappears
// with the items under it rather than sitting there empty.
export const navOptions = [
  {
    icon: HomeOutlinedIcon,
    selectedIcon: HomeIcon,
    label: "Home",
    link: "/home",
    permission: PERMISSIONS.PAGE_HOME,
  },
  {
    icon: CalendarMonthOutlinedIcon,
    selectedIcon: CalendarMonthIcon,
    label: "Shows",
    link: "/shows",
    permission: PERMISSIONS.PAGE_SHOWS,
  },
  {
    icon: PeopleOutlinedIcon,
    selectedIcon: PeopleIcon,
    label: "Waitlist",
    link: "/waitlist",
    permission: PERMISSIONS.PAGE_WAITLIST,
  },
  {
    icon: ReceiptLongOutlinedIcon,
    selectedIcon: ReceiptLongIcon,
    label: "Orders",
    link: "/orders",
    permission: PERMISSIONS.PAGE_ORDERS,
  },
  {
    icon: InboxIcon,
    selectedIcon: InboxIcon,
    label: "Requests",
    link: "/requests",
    permission: PERMISSIONS.PAGE_REQUESTS,
  },

  // ─── Programming ──────────────────────────────────────────────────────────
  {
    label: "Programming",
    section: true,
    permission: PERMISSIONS.PAGE_PERFORMERS,
  },
  {
    icon: TheaterComedyOutlinedIcon,
    selectedIcon: TheaterComedyIcon,
    label: "Performers",
    link: "/performers",
    permission: PERMISSIONS.PAGE_PERFORMERS,
  },
  {
    icon: ApartmentIcon,
    selectedIcon: ApartmentIcon,
    label: "Locations",
    link: "/locations",
    permission: PERMISSIONS.PAGE_LOCATIONS,
  },
  {
    icon: PartyPopperIcon,
    selectedIcon: PartyPopperIcon,
    label: "Festivals",
    link: "/festivals",
    permission: PERMISSIONS.PAGE_FESTIVALS,
  },
  {
    icon: LockIcon,
    selectedIcon: LockIcon,
    label: "Passwords",
    link: "/passwords",
    permission: PERMISSIONS.PAGE_PASSWORDS,
  },

  // ─── Store ────────────────────────────────────────────────────────────────
  {
    label: "Store",
    section: true,
    permission: PERMISSIONS.PAGE_MERCH,
  },
  {
    icon: StorefrontIcon,
    selectedIcon: StorefrontIcon,
    label: "Merch",
    link: "/merch",
    permission: PERMISSIONS.PAGE_MERCH,
  },
  {
    icon: LocalOfferIcon,
    selectedIcon: LocalOfferIcon,
    label: "Promos",
    link: "/promos",
    permission: PERMISSIONS.PAGE_PROMOS,
  },

  // ─── Marketing ────────────────────────────────────────────────────────────
  {
    label: "Marketing",
    section: true,
    permission: PERMISSIONS.PAGE_EMAILS,
  },
  {
    icon: MailIcon,
    selectedIcon: MailIcon,
    label: "Emails",
    link: "/marketing/emails",
    permission: PERMISSIONS.PAGE_EMAILS,
  },
  {
    icon: FileTextIcon,
    selectedIcon: FileTextIcon,
    label: "Templates",
    link: "/marketing/templates",
    permission: PERMISSIONS.PAGE_TEMPLATES,
  },
  {
    icon: LinkIcon,
    selectedIcon: LinkIcon,
    label: "Links",
    link: "/marketing/links",
    permission: PERMISSIONS.PAGE_LINKS,
  },

  // ─── Tools ────────────────────────────────────────────────────────────────
  {
    label: "Tools",
    section: true,
    permission: PERMISSIONS.PAGE_AUTOMATIONS,
  },
  {
    icon: WorkflowIcon,
    selectedIcon: WorkflowIcon,
    label: "Automations",
    link: "/tools/automations",
    permission: PERMISSIONS.PAGE_AUTOMATIONS,
  },
  {
    icon: MessagesSquareIcon,
    selectedIcon: MessagesSquareIcon,
    label: "Communications",
    link: "/tools/communications",
    permission: PERMISSIONS.PAGE_COMMUNICATIONS,
  },
  {
    icon: ListChecksIcon,
    selectedIcon: ListChecksIcon,
    label: "Show Checklists",
    link: "/tools/checklists",
    permission: PERMISSIONS.PAGE_CHECKLISTS,
  },
  {
    icon: AnalyticsOutlinedIcon,
    selectedIcon: AnalyticsIcon,
    label: "Analytics",
    link: "/analytics",
    permission: PERMISSIONS.PAGE_ANALYTICS,
  },
];
